import { Box, styled } from '@mui/material';
import { BaseMrpButton } from 'components/mrp/components/AppointmentForm/AppointmentForm.styles';

export const ToggleButton = styled(BaseMrpButton)(({ theme }) => ({
  '&.outlined': {
    border: '1px solid',
    borderColor: theme.vars.palette.outline.variant
  },
  '&.borderless': {
    border: 'none',
    padding: `${theme.spacing(1)} ${theme.spacing(0.5)} ${theme.spacing(1.5)}`,
    borderRadius: '2px',
    marginBottom: theme.spacing(0.5)
  },
  '&:hover hr': {
    borderColor: theme.palette.primary.main
  }
}));

export const IconBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginRight: theme.spacing(1),
  marginLeft: theme.spacing(0.5),
  fontSize: '16px'
}));

export const VAlignBox = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  width: '100%'
});

export const Separator = styled('hr')(({ theme }) => ({
  margin: `0 ${theme.spacing(1)} 0 ${theme.spacing(2)}`,
  borderColor: theme.vars.palette.outline.variant,
  flex: '1',
  '&.invisible': {
    borderWidth: 0
  }
}));
